import React, { FC } from 'react';
import ButtonMultiSelect from '@narvar/nth-button-multiselect';
import { StyledTimeSelect } from '../styled';
import { ITimesList } from '../types';
import { useTranslator } from '../utils/translator';

const buttonTheme = ({
  disabled,
  active,
}: Record<string, boolean>): React.CSSProperties => {
  const base: React.CSSProperties = {
    backgroundColor: 'white',
    borderStyle: 'line',
    color: 'black',
    width: '400px',
    textAlign: 'left',
    justifyContent: 'space-between',
    marginBottom: '5px',
  };

  if (active) {
    return {
      ...base,
      fontWeight: 'lighter',
    };
  }

  if (disabled) {
    return {
      ...base,
    };
  }

  return base;
};

interface IProps {
  list: ITimesList[];
  onSelect: (index: number) => void;
}

const TimeSelector: FC<IProps> = (props) => {
  const { list, onSelect } = props;
  const { t } = useTranslator();

  const handleButtonSelect = (index: number) => {
    onSelect(index);
  };

  return (
    <StyledTimeSelect
      style={{
        overflowY: 'auto',
        maxHeight: '260px',
        overflowX: 'hidden',
        width: 'auto',
      }}
    >
      <div>
        {list.length > 0 ? (
          <ButtonMultiSelect
            buttonTheme={buttonTheme}
            selectList={list}
            onButtonSelect={handleButtonSelect}
          />
        ) : (
          <p style={{ width: '100%', textAlign: 'center' }}>
            <br />
            {t(
              'Sorry no time slot available for this day, please select any other day.',
            )}
          </p>
        )}
      </div>
    </StyledTimeSelect>
  );
};

export default TimeSelector;
